<template>
    <div>
        <b-row>
            <b-col>
                <span class="t-title">
                    {{ $t("Set password") }}
                </span>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <b-form-input type="password" @keyup.enter="forgot_password" v-model="password"
                    placeholder="Password" />
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <b-form-input type="password" @keyup.enter="forgot_password" v-model="password2"
                    placeholder="Confirm Password" />
            </b-col>
        </b-row>
        <br>
        <b-row class="mt-3">
            <b-col>
                <b-button @click="resetPassword" class="bg-t-blue" block variant="primary">
                    {{ $t("Submit") }}
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-button @click="forgot_password" class="bg-t-blue" block variant="primary">
                    {{ $t("Back") }}
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            password: '',
            password2: '',
        }
    },
    methods: {
        forgot_password() {
            this.$parent.set_password = false
        },
        resetPassword() {
            if (this.password == this.password2) {
                this.$utils.request(
                    'account/confirm_password_change/',
                    'POST',
                    {
                        password: this.password,
                    },
                    (r) => {
                        console.log(r)
                    }
                )
            } else {
                this.$utils.customAlert(
                    'Check your password and try again',
                    'w'
                )
            }
        }
    }
}
</script>

<style></style>